"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ArrowPrev = exports.ArrowNext = void 0;
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread2"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Navigateleft = _interopRequireDefault(require("@nerdwallet/react-icon/gizmo/Navigateleft"));
var _Navigateright = _interopRequireDefault(require("@nerdwallet/react-icon/gizmo/Navigateright"));
var _utils = _interopRequireDefault(require("./utils"));
var _excluded = ["className"],
  _excluded2 = ["className"];
var handleClick = function handleClick(e, _ref) {
  var id = _ref.id,
    impression = _ref.impression,
    elementContent = _ref.elementContent,
    onClick = _ref.onClick,
    arrowClickCallback = _ref.arrowClickCallback;
  (0, _utils.default)(id, impression, 'press');
  if (onClick) {
    // default click behavior
    onClick(e);
  }
  if (arrowClickCallback) {
    arrowClickCallback(elementContent);
  }
};
var ArrowPrev = function ArrowPrev(_ref2) {
  var className = _ref2.className,
    props = (0, _objectWithoutProperties2.default)(_ref2, _excluded);
  return /*#__PURE__*/_react.default.createElement("button", {
    onClick: function onClick(event) {
      return handleClick(event, (0, _objectSpread2.default)({
        elementContent: 'prev'
      }, props));
    },
    className: className,
    type: "button"
  }, /*#__PURE__*/_react.default.createElement(_Navigateleft.default, null));
};
exports.ArrowPrev = ArrowPrev;
var ArrowNext = function ArrowNext(_ref3) {
  var className = _ref3.className,
    props = (0, _objectWithoutProperties2.default)(_ref3, _excluded2);
  return /*#__PURE__*/_react.default.createElement("button", {
    onClick: function onClick(event) {
      return handleClick(event, (0, _objectSpread2.default)({
        elementContent: 'next'
      }, props));
    },
    className: className,
    type: "button"
  }, /*#__PURE__*/_react.default.createElement(_Navigateright.default, null));
};
exports.ArrowNext = ArrowNext;
var arrowPropTypes = {
  /** ID used for tracking purposes. */
  id: _propTypes.default.string,
  /** Classes to apply to the arrow. */
  className: _propTypes.default.string,
  /** The impression fired by the parent Carousel */
  impression: _propTypes.default.string,
  /** Optional click handler to call after default navigation. */
  arrowClickCallback: _propTypes.default.func
};
ArrowPrev.propTypes = arrowPropTypes;
ArrowNext.propTypes = arrowPropTypes;